import Loader from '../Loader'
import LandingButtonSvg from './LandingButtonSvg'

type Props = {
  name?: string
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  textAlign?: string
  t: any
}

const ALIGNEMT = {
  left: 'text-left',
  center: 'text-center',
}

const LandingButton: React.FC<Props> = ({
  name,
  loading,
  disabled,
  onClick,
  textAlign,
  t,
}) => {
  const textAlignment = ALIGNEMT[textAlign]

  return (
    <div className="flex flex-row group">
      {name && <LandingButtonSvg name={name} />}
      <button
        name={name}
        type="submit"
        className={`w-64 min-h-9 block ${textAlignment} overflow-hidden rounded-md text-green-800 font-bold px-4 py-2 leading-5 bg-gold-100 group-hover:bg-gold-200 active:bg-gold-300 focus:outline-none`}
        disabled={disabled}
        onClick={onClick}
      >
        {loading ? <Loader /> : t(`button.${name}`)}
      </button>
    </div>
  )
}

export default LandingButton
